import { useEffect, useState } from 'react';

// Types
import { AoyTournamentType, IAoyTableRow } from '../types';

// Util
import * as api from '../util/api';
import { refreshRate } from './../util/util';
import pointsStandingsParams from './../util/pointsStandingsParams';

const apiUri = (type, year) => {
  const query = pointsStandingsParams(type, year);
  if (type === AoyTournamentType.ROY) {
    return `/wp-json/data/v1/points-standings-roy?${query}`;
  }
  return `/wp-json/data/v1/points-standings?${query}`;
};

const AOY_FETCH_RATE = refreshRate([0, 0]);

// Hook will return the AOY table data.
const useAoyHistoric = (type: AoyTournamentType, year?: number) => {
  const [aoyhistoric, setAoyhistoric] = useState<IAoyTableRow[]>([]);

  useEffect(() => {
    /**
     * Set state for the AOY historic when api returns.
     * NOTE: *returns a function to capture scope*
     */
    const storeAoyHistoric = () => (response: IAoyTableRow[]) => {
      setAoyhistoric(response);
    };

    (async () => {
      await api.subscribe({
        callback: storeAoyHistoric(),
        rate: AOY_FETCH_RATE,
        uri: apiUri(type, year),
      });
    })();
  }, [type, year]);

  return aoyhistoric;
};

export default useAoyHistoric;
